<template>
    <div>
        <v-card class="pa-2">
            <canvas id="chart2" ref="chart2" height="184" ></canvas>
        </v-card>
    </div>
</template>

<script>
import Chart from 'chart.js';

export default {
    data() {
        return {
            chart: null,
            canvas: null,
            loading: true,
            data: [],
            labels: []
        }
    },
    watch: {
        chartData() {
            this.render();
        }
    },
    props: {
        chartData: Array
    },
    mounted() {
        this.render();
    },
    methods: {
        render() {
            if(this.chart && this.canvas) {
                this.chart.destroy();
                this.canvas = null;
            }

            
            this.labels = JSON.parse(this.chartData[0].labels);
            this.data = JSON.parse(this.chartData[0].dataset).map(Number);

            this.canvas = this.$refs['chart2'].getContext('2d');

            this.chart = new Chart(this.canvas, {
                type: 'doughnut',
                data: {
                    datasets: [{
                        data: this.data,
                        backgroundColor: ["#0D47A1", "#90CAF9", "#82B1FF", "#448AFF"]
                    }],
                    labels: this.labels,
                    
                },
                options: {
                    title: {
                        display: true,
                        text: 'Volume By Card Type',
                        fontSize: 12,
                        fontStyle: 400,
                        // fontColor: '#000'
                    },
                }
            })
        }
    }
}
</script>

<style>

</style>